import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { fetchMoviesWithFallback } from "../utilities/fetchWithFallback"
import {addTopRatedMovies} from "../utilities/movieSlice"

const useTopRatedMovies=()=>{
     const dispatch=useDispatch();
     useEffect(()=>{
    const getTopRatedMovies=async ()=>{
        const results = await fetchMoviesWithFallback('https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1', 'top_rated');
        dispatch(addTopRatedMovies(results))
    }
    getTopRatedMovies();
},[dispatch])
}
export default useTopRatedMovies;